import React, { useState, useEffect } from 'react';
import { Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import ListadoDocumentos from '../listadoDocumentos/ListadoDocumentos';
import BuscarDocumentos from '../buscarDocumentos/BuscarDocumentos';
import PaginarDocumentos from '../listadoDocumentos/PaginarDocumentos';
import { clearErrors } from '../../actions';
import {
  ValidarEmisor,
  ValidarLogin,
  getCurrentDate,
  addDayToDate,
  getCasaMatriz
} from '../../util';
import { documentTypeEnum } from '../../enum';
import RenderHeader from '../shared/RenderHeader';

const NotasDebito = (props) => {
  const { token } = ValidarLogin(props);
  const { emisor } = ValidarEmisor(props);
  const { notasDebitoState, errorState } = props;
  const [documentos, setDocumentos] = useState([]);
  const [totalRegistros, setTotalRegistros] = useState(0)
  const [pageSize, setPageSize] = useState(15);
  const [request, setRequest] = useState({
    Identificacion: emisor?.Identificacion.Numero,
    CasaMatriz: getCasaMatriz(emisor?.usuario),
    FechaInicio: addDayToDate(getCurrentDate(), -30),
    FechaFin: addDayToDate(getCurrentDate(), + 1),
    NumeroPagina: 1,
    TamanoPagina: 15
  });

  useEffect(() => {
    props.clearErrors();
  }, []);

  useEffect(() => {
    if (notasDebitoState !== null && errorState?.error === null) {
      setDocumentos(notasDebitoState.facturas.DocumentosElectronicos);
      setTotalRegistros(notasDebitoState.facturas.TotalRegistros);
    }
    else {
      setDocumentos([]);
      setTotalRegistros(0);
    }
  }, [notasDebitoState]);

  if (token === null) {
    return <Redirect to='/login' />;
  }

  const onNextPage = (pageNumber) => {
    setRequest({
      ...request,
      NumeroPagina: pageNumber,
      TamanoPagina: pageSize
    });
  };

  return (
    <div className="ui Lista-facturas-container">

      <RenderHeader titulo="NOTAS DE DÉBITO" />
      <BuscarDocumentos docType={documentTypeEnum.NotaDebito} token={token} emisor={emisor} numeroPagina={request.NumeroPagina} tamanoPagina={request.TamanoPagina} />
      <ListadoDocumentos documentos={documentos} docType={documentTypeEnum.NotaDebito} token={token.access_token} />
      <PaginarDocumentos pageSize={pageSize} totalRegistros={totalRegistros} onGetNextPage={(pageNumber) => {
        onNextPage(pageNumber);
      }} />
    </div>
  )
};

const mapStateToProps = (state) => {
  return {
    errorState: state.errorState,
    loginState: state.loginState,
    emisorState: state.emisorState,
    notasDebitoState: state.notasDebitoState,
  };
};

export default connect(mapStateToProps, { clearErrors })(NotasDebito);